<template>

	<!-- Page header -->
	<div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
					<a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click="getAccessi()"> Accessi </a> 
					<span class="hidden-xs ms-1">\</span>
					<span class="text-muted ms-1"> Log Accessi </span>
				</h4>
				<a href="#page_header" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
			</div>
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">

					<div class="vr flex-shrink-0 my-2 mx-3"></div>

					<div class="d-inline-flex float-end mt-sm-0">
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.confTravelLingue(this.modulo)" title="Definizioni Lingua" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-flag"></i>
						</a>
						<a href="#" class="btn btn-outline-pink btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.help(this.modulo)" title="Help OnLIne" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="icon-question7 pink"></i>
						</a>
	                </div>
				</div>
			</div>
		</div>
		<!-- /breadcrumb -->

		<!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded cursor-pointer" :class="{active: activeTab == 'accessi-a'}" v-on:click="activeTab = 'accessi-a', getAccessi(activeTab,idEnteCorrente)" data-bs-toggle="tab" aria-selected="true" role="tab" tabindex="-1">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-list"></i>
								<span class="hidden-lg ms-1">Admin</span>
								<span class="hidden-xs ms-1">Log Admin</span>
							</div>
						</a>
					</li>
					<li class="nav-item me-1" role="presentation">
						<a  class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded cursor-pointer" :class="{active: activeTab == 'accessi-b'}" v-on:click="activeTab = 'accessi-b', getAccessi(activeTab,idEnteCorrente)" data-bs-toggle="tab" aria-selected="false" role="tab">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-circles-four"></i>  
								<span class="hidden-lg ms-1">Agenzie</span>
								<span class="hidden-xs ms-1">Log Agenzie</span>
							</div>
						</a>
					</li>
					<li class="nav-item me-1" role="presentation">
						<a class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded cursor-pointer"  :class="{active: activeTab == 'accessi-c'}" v-on:click="activeTab = 'accessi-c', getAccessi(activeTab,idEnteCorrente)" data-bs-toggle="tab" aria-selected="false" role="tab">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-bandaids"></i>
								<span class="hidden-lg ms-1">Utenti</span>
								<span class="hidden-xs ms-1">Log Utenti</span>
							</div>
						</a>
					</li>
					<li class="nav-item d-lg-none ms-auto">
						<a href="#profile_nav" class="navbar-nav-link navbar-nav-link-icon rounded-pill rounded-pill-small collapsed" data-bs-toggle="collapse" aria-expanded="false">
							<i class="ph-caret-down collapsible-indicator"></i>
						</a>
					</li>
				</ul>

				<div class="navbar-collapse collapse" id="profile_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
						<li class="nav-item dropdown ms-lg-1">
							<div class="btn-group">

							</div>
						</li>  
						<li class="nav-item">

						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- /profile navigation -->	

	</div>
	<!-- /page header -->
	
	<!-- Content area -->
    <div class="content content-1 table-cms-wrapper">

		<div class="tab-content flex-1 order-2 order-lg-1">

			<div class="tab-pane fade" id="accessi-a" :class="{'active show': activeTab == 'accessi-a'}">
				<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse" role="button" aria-expanded="false">
								MOSTRA FILTRI
							</a>
						</div>
					</div>
					<div class="collapse" :class="{ show: !$root.isMobile }" id="collapse-all" style="">				
		                <div class="card-body pb-0">
		                    <div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" id="accesso-a">
									<div class="row">
										<div class="col-4 col-md-1 col-lg-1 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" placeholder="Id Accesso" type="text" v-model="searchAdmin.ID_ACCESSO.VALUE">
										</div> 
										<div class="col-8 col-md-2 col-lg-2 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" placeholder="Username" type="text" v-model="searchAdmin.USERNAME.VALUE">
										</div>           
										<div class="col-12 col-md-2 mbx-1">
											<Datepicker  v-model="searchAdmin.DATA_ACCESSO.VALUE" model-type="dd/MM/yyyy" :formats="{ input: 'dd/MM/yyyy' }" auto-apply :hide-navigation="['time']"></Datepicker>	
										</div>          
										<div class="col-6 col-md-6">
										</div>
										<div class="col-6 col-md-1 col-lg-1">
			                                <a class="btn btn-flat-info btn-sm w-100" data-bs-toggle="collapse" v-on:click="getAccessi(activeTab,idEnteCorrente)" role="button" aria-expanded="false">
												<span style="font-weight: 500;">Aggiorna</span>				
											</a>          
										</div>  
									</div>
								</form>
		                    </div>
						</div>
					</div>

			        <div class="card-body box-card mt-0 mb-0" id="box-card">
						<div class="div_table_resp tableFixHead" id="tableFixHead">
		               		<table class="table table-bordered table-hover table-striped table-togglable text-nowrap"> 
			                    <thead class="sticky-top">
			                        <tr class="bg-secondary text-white">
										<th class="table-head-sm" style="width:13%;"><span>Data e ora</span></th>
										<th class="table-head-sm" style="width:30%;"><span >Username</span></th>
										<th class="table-head-sm" style="width:10%;"><span >Ip</span></th>
										<th class="table-head-sm" style="width:10%;"><span >Valore</span></th>
										<th class="table-head-sm" style="width:27%;">Azione</th>
										<th class="table-head-sm" style="width:10%;">Stato</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="accesso in paginatedListAdmin.arr" v-bind:key="accesso.ID_ACCESSO">
										<td class="td-class fs-sm">
											<span class="text-dark"><i class="fal fa-calendar-alt fa-fw me-1"></i>{{accesso.DATA_ACCESSO}}</span>
										</td>
										<td class="td-class fs-sm">
											<span class="text-primary fw-bold">{{accesso.USERNAME}}</span>
										</td>
										<td class="td-class fs-sm">
											<span>{{accesso.INDIRIZZO_IP}}</span>
										</td>
										<td class="td-class fs-sm">
											<span v-if="accesso.VALORE == 1">LogIn</span>
											<span v-else-if="accesso.VALORE == 2">Otp</span>
											<span v-else-if="accesso.VALORE == 3">LogOut</span>
											<span v-else>Errore</span>
										</td>
		                                <td class="td-class">
											<span class="text-success" v-if="accesso.ESITO == 0">Operazione correttamente eseguita</span>
											<span class="text-warning" v-else-if="accesso.ESITO == 2">L'utente non è ancora abilitato all'accesso</span>
											<span class="text-danger" v-else-if="accesso.ESITO == 3">Nome utente o password errati</span>
											<span class="text-pink" v-else-if="accesso.ESITO == 30">L'utente non è stato trovato</span>
										</td>
		                                <td class="td-class">
	                                       {{ accesso.FLG_ATTIVO == 1 ? "Connesso" : "Disconnesso" }} 
										</td>
									</tr>
								</tbody>
							</table>     
                   		</div>
		
		                <div class="row page-bottom">
							<div class="col-12 col-md-5 d-none d-sm-block" :tabindex="27">
                                <div style="position: relative; top: 10px;">
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2"></span> 
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 ms-2"></span>
                                </div>
                            </div>
							<div class="col-9 col-md-6" :tabindex="27">
		                        <div class="float-end pag-mobile">
									<Pagine v-model="searchAdmin.PAGINATION.PAGE_NUMBER" :numrighe="paginatedListAdmin.count" :numpagine="searchAdmin.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
		                        </div>
	                        </div>
							<div class="col-3 col-md-1" :tabindex="28">
								<select class="form-select form-select-sm wmin-100 mt-2 float-end" data-placeholder="Limite" :tabindex="20" v-model="searchAdmin.PAGINATION.PAGE_SIZE" style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
		                            <option value="5">5</option>
		                            <option value="10">10</option>
		                            <option value="25">25</option>
		                            <option value="50">50</option>
		                            <option value="75">75</option>
		                            <option value="100">100</option>
		                            <option value="250">250</option>
		                            <option value="500">500</option>
		                        </select>
                            </div>
						</div>
					</div>
				</div>
			</div>
						
			<div class="tab-pane fade" :class="{'active show': activeTab == 'accessi-b'}" id="accessi-b">	
				<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse" role="button" aria-expanded="false">
								MOSTRA FILTRI
							</a>
						</div>
					</div>
					<div class="collapse" :class="{ show: !$root.isMobile }" id="collapse-all" style="">				
		                <div class="card-body pb-0">
		                    <div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" id="accesso-a">
									<div class="row">
										<div class="col-4 col-md-1 col-lg-1 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" placeholder="Id Accesso" type="text" v-model="searchAgency.ID_ACCESSO.VALUE">
										</div> 
										<div class="col-8 col-md-2 col-lg-2 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" placeholder="Username" type="text" v-model="searchAgency.USERNAME.VALUE">
										</div>           
										<div class="col-12 col-md-2 mbx-1">
											<Datepicker  v-model="searchAgency.DATA_ACCESSO.VALUE" model-type="dd/MM/yyyy" :formats="{ input: 'dd/MM/yyyy' }" auto-apply :hide-navigation="['time']"></Datepicker>	
										</div>          
										<div class="col-6 col-md-6">
										</div>
										<div class="col-6 col-md-1 col-lg-1">
			                                <a class="btn btn-flat-info btn-sm w-100" data-bs-toggle="collapse" v-on:click="getAccessi(activeTab,idEnteCorrente)" role="button" aria-expanded="false">
												<span style="font-weight: 500;">Aggiorna</span>				
											</a>          
										</div>  
									</div>
								</form>
		                    </div>
						</div>
					</div>

			        <div class="card-body box-card mt-0 mb-0" id="box-card">
						<div class="div_table_resp tableFixHead" id="tableFixHead">
		               		<table class="table table-bordered table-hover table-striped table-togglable text-nowrap"> 
			                    <thead class="sticky-top">
			                        <tr class="bg-secondary text-white">
										<th class="table-head-sm" style="width:13%;"><span>Data e ora</span></th>
										<th class="table-head-sm" style="width:30%;"><span >Username</span></th>
										<th class="table-head-sm" style="width:10%;"><span >Ip</span></th>
										<th class="table-head-sm" style="width:10%;"><span >Valore</span></th>
										<th class="table-head-sm" style="width:27%;">Azione</th>
										<th class="table-head-sm" style="width:10%;">Stato</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="accesso in paginatedListAgency.arr" v-bind:key="accesso.ID_ACCESSO">
										<td class="td-class fs-sm">
											<span class="text-dark"><i class="fal fa-calendar-alt fa-fw me-1"></i>{{accesso.DATA_ACCESSO}}</span>
										</td>
										<td class="td-class fs-sm">
											<span class="text-primary fw-bold">{{accesso.USERNAME}}</span>
										</td>
										<td class="td-class fs-sm">
											<span>{{accesso.INDIRIZZO_IP}}</span>
										</td>
										<td class="td-class fs-sm">
											<span v-if="accesso.VALORE == 1">LogIn</span>
											<span v-else-if="accesso.VALORE == 2">Otp</span>
											<span v-else-if="accesso.VALORE == 3">LogOut</span>
											<span v-else>Errore</span>
										</td>
		                                <td class="td-class">
											<span class="text-success" v-if="accesso.ESITO == 0">Operazione correttamente eseguita</span>
											<span class="text-warning" v-else-if="accesso.ESITO == 2">L'utente non è ancora abilitato all'accesso</span>
											<span class="text-danger" v-else-if="accesso.ESITO == 3">Nome utente o password errati</span>
											<span class="text-pink" v-else-if="accesso.ESITO == 30">L'utente non è stato trovato</span>
										</td>
		                                <td class="td-class">
	                                       {{ accesso.FLG_ATTIVO == 1 ? "Connesso" : "Disconnesso" }} 
										</td>
									</tr>
								</tbody>
							</table>     
                   		</div>
		
		                <div class="row page-bottom">
							<div class="col-12 col-md-5 d-none d-sm-block" :tabindex="27">
                                <div style="position: relative; top: 10px;">
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2"></span> 
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 ms-2"></span>
                                </div>
                            </div>
							<div class="col-9 col-md-6" :tabindex="27">
		                        <div class="float-end pag-mobile">
									<Pagine v-model="searchAgency.PAGINATION.PAGE_NUMBER" :numrighe="paginatedListAgency.count" :numpagine="searchAgency.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
		                        </div>
	                        </div>
							<div class="col-3 col-md-1" :tabindex="28">
								<select class="form-select form-select-sm wmin-100 mt-2 float-end" data-placeholder="Limite" :tabindex="20" v-model="searchAgency.PAGINATION.PAGE_SIZE" style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
		                            <option value="5">5</option>
		                            <option value="10">10</option>
		                            <option value="25">25</option>
		                            <option value="50">50</option>
		                            <option value="75">75</option>
		                            <option value="100">100</option>
		                            <option value="250">250</option>
		                            <option value="500">500</option>
		                        </select>
                            </div>
						</div>
					</div>
				</div>
			</div>
		
			<div class="tab-pane fade" :class="{'active show': activeTab == 'accessi-c'}" id="accessi-c"> 
				<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse" role="button" aria-expanded="false">
								MOSTRA FILTRI
							</a>
						</div>
					</div>
					<div class="collapse" :class="{ show: !$root.isMobile }" id="collapse-all" style="">				
		                <div class="card-body pb-0">
		                    <div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" id="accesso-a">
									<div class="row">
										<div class="col-4 col-md-1 col-lg-1 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" placeholder="Id Accesso" type="text" v-model="searchUsers.ID_ACCESSO.VALUE">
										</div> 
										<div class="col-8 col-md-2 col-lg-2 mbx-1">
											<input autocomplete="off" class="form-control form-control-sm" placeholder="Username" type="text" v-model="searchUsers.USERNAME.VALUE">
										</div>           
										<div class="col-12 col-md-2 mbx-1">
											<Datepicker  v-model="searchUsers.DATA_ACCESSO.VALUE" model-type="dd/MM/yyyy" :formats="{ input: 'dd/MM/yyyy' }" auto-apply :hide-navigation="['time']"></Datepicker>	
										</div>          
										<div class="col-6 col-md-6">
										</div>
										<div class="col-6 col-md-1 col-lg-1">
			                                <a class="btn btn-flat-info btn-sm w-100" data-bs-toggle="collapse" v-on:click="getAccessi(activeTab,idEnteCorrente)" role="button" aria-expanded="false">
												<span style="font-weight: 500;">Aggiorna</span>				
											</a>          
										</div>  
									</div>
								</form>
		                    </div>
						</div>
					</div>

			        <div class="card-body box-card mt-0 mb-0" id="box-card">
						<div class="div_table_resp tableFixHead" id="tableFixHead">
		               		<table class="table table-bordered table-hover table-striped table-togglable text-nowrap"> 
			                    <thead class="sticky-top">
			                        <tr class="bg-secondary text-white">
										<th class="table-head-sm" style="width:13%;"><span>Data e ora</span></th>
										<th class="table-head-sm" style="width:30%;"><span >Username</span></th>
										<th class="table-head-sm" style="width:10%;"><span >Ip</span></th>
										<th class="table-head-sm" style="width:10%;"><span >Valore</span></th>
										<th class="table-head-sm" style="width:27%;">Azione</th>
										<th class="table-head-sm" style="width:10%;">Stato</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="accesso in paginatedListUsers.arr" v-bind:key="accesso.ID_ACCESSO">
										<td class="td-class fs-sm">
											<span class="text-dark"><i class="fal fa-calendar-alt fa-fw me-1"></i>{{accesso.DATA_ACCESSO}}</span>
										</td>
										<td class="td-class fs-sm">
											<span class="text-primary fw-bold">{{accesso.USERNAME}}</span>
										</td>
										<td class="td-class fs-sm">
											<span>{{accesso.INDIRIZZO_IP}}</span>
										</td>
										<td class="td-class fs-sm">
											<span v-if="accesso.VALORE == 1">LogIn</span>
											<span v-else-if="accesso.VALORE == 2">Otp</span>
											<span v-else-if="accesso.VALORE == 3">LogOut</span>
											<span v-else>Errore</span>
										</td>
		                                <td class="td-class">
											<span class="text-success" v-if="accesso.ESITO == 0">Operazione correttamente eseguita</span>
											<span class="text-warning" v-else-if="accesso.ESITO == 2">L'utente non è ancora abilitato all'accesso</span>
											<span class="text-danger" v-else-if="accesso.ESITO == 3">Nome utente o password errati</span>
											<span class="text-pink" v-else-if="accesso.ESITO == 30">L'utente non è stato trovato</span>
										</td>
		                                <td class="td-class">
	                                       {{ accesso.FLG_ATTIVO == 1 ? "Connesso" : "Disconnesso" }} 
										</td>
									</tr>
								</tbody>
							</table>     
                   		</div>
		
		                <div class="row page-bottom">
							<div class="col-12 col-md-5 d-none d-sm-block" :tabindex="27">
                                <div style="position: relative; top: 10px;">
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2"></span> 
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 ms-2"></span>
                                </div>
                            </div>
							<div class="col-9 col-md-6" :tabindex="27">
		                        <div class="float-end pag-mobile">
									<Pagine v-model="searchUsers.PAGINATION.PAGE_NUMBER" :numrighe="paginatedListUsers.count" :numpagine="searchUsers.PAGINATION.LENGTH" :modalita="$root.isMobile ? 2 : 1"></Pagine>
		                        </div>
	                        </div>
							<div class="col-3 col-md-1" :tabindex="28">
								<select class="form-select form-select-sm wmin-100 mt-2 float-end" data-placeholder="Limite" :tabindex="20" v-model="searchUsers.PAGINATION.PAGE_SIZE" style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
		                            <option value="5">5</option>
		                            <option value="10">10</option>
		                            <option value="25">25</option>
		                            <option value="50">50</option>
		                            <option value="75">75</option>
		                            <option value="100">100</option>
		                            <option value="250">250</option>
		                            <option value="500">500</option>
		                        </select>
                            </div>
						</div>
					</div>
				</div>
			</div>

		</div> 
	</div>

					
	<!-- START MODALI -->
	<div class="modal fade" id="popUpStackTrace" tabindex="-1" role="dialog"  >
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header modal-header-2 bg-danger text-white">
					<h6 class="modal-title">Log dettaglio Accesso</h6>
					<button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">X</button>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-2 form-group-1"><label class="font-weight-semibold">File:</label></div>
						<div class="col-md-10 form-group-1"><input type="text" class="form-control" v-model="accessoSelezionato.message" /></div>
						<div class="col-md-2"><label class="font-weight-semibold">Descrizione:</label></div>
						<div class="col-md-10"><p>{{getStringAccesso(accessoSelezionato)}}</p></div>
					</div>                      
					<pre class="box_error" style="font-size:10px" v-if="accessoSelezionato.hasOwnProperty('stackTrace')">
						<strong>{{ accessoSelezionato.context.utente }}</strong><br/>
						{{accessoSelezionato.stackTrace}}<br/>
						{{accessoSelezionato.context.parametri}}
					</pre>
					<pre style="font-size:10px" v-else>{{accessoSelezionato.context}}</pre>
				</div>
				<div class="modal-footer">

				</div>
			</div>
		</div>
	</div>

        
</template>
			


<script>

import Pagine from '@/components/utils/Pagine.vue'
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker'


export default {
    name:"ConfAccessi",

    components:{
        Pagine,
        Datepicker,
    
    }, 

    data: function () {
        return {   
			apiStartup:'core/accessi/log',
			filters:global.filters,
            GLOBAL_IMAGES_PATH:'',
			anno:new Date().getFullYear(),
            arrayAccessi: new Array(),
            selectedMenuItem:{},
            searchAdmin:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
                ID_ACCESSO:{TYPE:'TEXT',VALUE:''},
                USERNAME:{TYPE:'TEXT',VALUE:''},
				DATA_ACCESSO:{TYPE:'DATE_TIME',VALUE:''},

            },
            searchAgency:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
                ID_ACCESSO:{TYPE:'TEXT',VALUE:''},
                USERNAME:{TYPE:'TEXT',VALUE:''},
				DATA_ACCESSO:{TYPE:'DATE_TIME',VALUE:''},

            },
            searchUsers:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
                ID_ACCESSO:{TYPE:'TEXT',VALUE:''},
                USERNAME:{TYPE:'TEXT',VALUE:''},
				DATA_ACCESSO:{TYPE:'DATE_TIME',VALUE:''},

            },
            accessoSelezionato:{},
			activeTab: 'accessi-a',
			idEnteCorrente : 0,
        }
    },

    methods: {
        getAccessi: function (activeTab,idEnte){
			this.idEnteCorrente = idEnte;
            utils.get(this.apiStartup,{activeTab : activeTab,FK_ID_ENTE:idEnte}, (response) => {
                this.arrayAccessi = response.data;
				for (let i = 0; i < this.arrayAccessi.length; i++) {
					this.arrayAccessi[i].DATA_ACCESSO = this.filters.formatDateTimeSeconds(this.arrayAccessi[i].DATA_ACCESSO);
				}
            });
        },

        getStringAccesso:function(_accesso){
            var item = _accesso.context;
            if (item == undefined)
                return "";
            if (item.hasOwnProperty("message")){
                return item.message;
            }
            else {
                if (item.hasOwnProperty("query")){
                    return item.accesso ;
                }
                return "";
            }
        },

        openStackTrace:function(accesso){
			this.filters.openPopUp("popUpStackTrace"); 		
            this.accessoSelezionato = utils.clone(accesso);
            if (this.accessoSelezionato.context.hasOwnProperty("message")){
                this.accessoSelezionato.stackTrace = this.accessoSelezionato.context.stackTrace;
            }
            else {
                if (this.accessoSelezionato.context.hasOwnProperty("query")){
                    this.accessoSelezionato.stackTrace = this.accessoSelezionato.context.query; //+ "\n\n---\n" + this.accessoSelezionato.context.parametri.join(",") ;
                }
            }
        },

        refreshEnte : function(){
            this.idEnteCorrente = this.$root.idEnteCorrente;
        	this.getAccessi(this.activeTab,this.idEnteCorrente);
        },

    }, 

    computed: {
        paginatedListAdmin(){
            var arr = utils.inGrid(this.arrayAccessi,this.searchAdmin);
            return arr;
        },

        paginatedListAgency(){
            var arr = utils.inGrid(this.arrayAccessi,this.searchAgency);
            return arr;
        },

        paginatedListUsers(){
            var arr = utils.inGrid(this.arrayAccessi,this.searchUsers);
            return arr;
        } 

    },		 

    created: function () {
		this.idEnteCorrente = this.$root.idEnteCorrente;
        this.getAccessi(this.activeTab,this.idEnteCorrente);
    },

}
</script>

